// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function LightningIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M26.974 14.771a1 1 0 0 0-.625-.707l-7.201-2.701 1.832-9.167a1 1 0 0 0-1.711-.875l-14 15a1 1 0 0 0 .375 1.625l7.204 2.701-1.828 9.157a1 1 0 0 0 1.711.875l14-15a1.001 1.001 0 0 0 .243-.908ZM13.67 26.75l1.309-6.547a1 1 0 0 0-.625-1.133L7.75 16.589 18.328 5.256l-1.308 6.548a1 1 0 0 0 .625 1.132l6.6 2.475L13.671 26.75Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
